(function () {

    a3_pilot_reports.directive('notifications', notifications);

       /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name notifications
   * @restrict E
   * @description
   *   Initialize panel with information messages about session's status and necessary actions
   * @example
   *   Usage:
   *   <notifications></notifications>
   * @ngInject
   */

    function notifications($routeParams) {
        function link(scope) {
            var info = {
                msg: "",
                border: "",
                text: "",
                showHistory: false
            };

            var date = $routeParams.date;
            scope.filterSession = filterSession;
            scope.selectSession = selectSession;
            scope.historyAvailable = false;
            scope.additionalTrainingRequested = false;
            scope.underAdditionalTraining = false;
            scope.showReleaseOption = false;

            //If already submitted : show submitted sessions menu and select first
            if(scope.course?.SubmittedSessions && scope.course?.SubmittedSessions.length){
                var submittedDay = scope.course.SubmittedSessions[0].DutyDay;
                var isSame = moment(date).isSame(submittedDay);
                if(isSame){
                    scope.course.historyAvailable = true;
                    scope.historyAvailable = true;
                    scope.selectedSubmittedSession = {             
                        sessionId: scope.course.SubmittedSessions[0].SessionId
                    }; 
                    scope.course.SubmittedSessions.forEach(function (submittedSession) {
                        submittedSession.TraineesSessions.forEach(function (traineeSession) {
                            scope.additionalTrainingRequested = traineeSession.NeedsAdditionalRequest;
                        });
                    });
                    scope.course.SubmittedSessions.forEach(function (submittedSession){
                         if(submittedSession.TraineesSessions.some(x => x.IsReleased == false && x.NeedsAdditionalRequest == false)){
                            scope.showReleaseOption = true;
                        };                            
                });
                }
            }

            // 1. Check if session has been already submitted 
            var isCourseComplete = scope.isCourseComplete
            if(isCourseComplete){

                info = {
                    msg : "Training form already submitted for this day.",
                    border : "border-left-orange",
                    text : "text-orange",
                    showHistory: true       //show what was submitted in read-only view
                };
            }

            // 2. Check if course is Outdated
            var isCourseOutdated = scope.isCourseOutdated;
            if (isCourseOutdated) {
                info = {
                    msg : "You have an outdated version of this course. Please Refresh Course.",
                    border : "border-left-orange",
                    text : "text-orange",
                    showHistory: false
                }
            }

            // 3. Check if course needs an initial fetch
            var isCourseLimited = scope.isCourseLimited;
            if (isCourseLimited && !isCourseComplete) {
                isCourseLimited = true;
                info = {
                    msg : "You need to perform an initial fetch to receive all available information.",
                    border : "border-left-blue",
                    text : "text-blue",
                    showHistory: false
                }
            }

            // Result
            scope.info = info;

            /**
             * Filter submitted sessions based on selected from the top menu
             * @returns if session is currently selected
             */
            function filterSession() {   
                return function( traineeSession ) {
                    var showSessionTrainees = false;
                    if (traineeSession.SessionId === scope.selectedSubmittedSession.sessionId){
                        showSessionTrainees = true;
                    }
                    return showSessionTrainees;
                };
            }

            function selectSession(sessionId){
                scope.selectedSubmittedSession.sessionId = sessionId;
            }
        }

        return {
            restrict: 'E',
            templateUrl: "views/Training/notifications.tpl.html",
            scope : false,
            terminal: true,
            link: link
        }
    }
})();